import React, { useEffect, useState } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import AppRoutes from './routes'
import { useAuthState } from './atoms/auth'
import Login from './pages/Login'
import apiClient from './service/api'
import authTokenStore from './auth/tokenStore'

function App() {
  const [authState, setAuthState] = useAuthState()
  const [isRestoring, setIsRestoring] = useState(true)

  useEffect(() => {
    const restoreSession = async () => {
      try {
        const res = await apiClient.post('/v1/auth/refresh')
        const newToken = res.data.accessToken

        authTokenStore.set(newToken)

        setAuthState((prev) => ({
          ...prev,
          loggedIn: true,
        }))
      } catch (e) {
        authTokenStore.clear()
        setAuthState((prev) => ({
          ...prev,
          loggedIn: false,
        }))
      } finally {
        setIsRestoring(false)
      }
    }

    restoreSession()
  }, [setAuthState])
  
  if (isRestoring) {
    return (
      <HelmetProvider>
        <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          Loading...
        </div>
      </HelmetProvider>
    )
  }

  return <HelmetProvider>{authState.loggedIn ? <AppRoutes /> : <Login />}</HelmetProvider>
}

export default App
